import {OPEN_MODAL, CLOSE_MODAL} from "./index";

export function openModal(modal) {
  return {type: OPEN_MODAL, modal}
}

export function closeModal(modal) {
  return {type: CLOSE_MODAL, modal}
}


// WEBPACK FOOTER //
// ./src/actions/modalActions.js